import getters from './getters'
import actions from './actions'
import mutations from './mutations'

 const api = {
    namespaced: true,
    strict: process.env.NODE_ENV !== 'production',
    state: {
      recordTypes: [],
      periodTypes: [],
    },
    getters,
    mutations,
    actions
  }

  export default api